<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            ©
            {{ new Date().getFullYear() }}, Desarrollado
            <i></i> por
            <!-- <a
              href=""
              class="font-weight-bold"
              target="_blank"
              >Daniel Almanza</a
            > -->
            <a
              href=""
              class="font-weight-bold"
              target="_blank"
              >4PLUS</a
            >
            .
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "app-footer",
};
</script>

<style scoped>
.footer {
  position: relative;
  z-index: 1;
}
</style>
